import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import { SessionMainText } from 'domain/assistant/session-elements';
import { AssistantStoreType } from 'models/AssistantStore';
import { ASSISTANTS, getStepInfo } from 'utils/constants/assistant-steps';
import { HistoryProps } from 'utils/history';
import ExplanationScreen from '../ExplanationScreen';

const SolutionIntroScreen = inject('assistantStore')(
  observer(
    ({
      location,
      assistantStore: { currentAssistantType }
    }: { assistantStore: AssistantStoreType } & HistoryProps) => {
      const stepInfo = getStepInfo('step3_1', currentAssistantType);

      return (
        <ExplanationScreen
          progress={
            stepInfo?.progress || ASSISTANTS.creative_session.step3_1.progress
          }
          barProgress={stepInfo?.percent}
          header={<FormattedMessage id="assistant solutions intro header" />}
          headerStep={stepInfo?.header}
          sidebarHeadline={stepInfo?.header}
          videoId="hCgMr0M9gGY"
          videoPreview="/images/assistant/video/solution_intro.png"
          timerSeconds={600}
          sidebarScrollTo="solutions"
          showHeader="solutions"
          location={location}
        >
          <SessionMainText>
            <FormattedMessage id="assistant solutions intro" />
          </SessionMainText>
        </ExplanationScreen>
      );
    }
  )
);

export default SolutionIntroScreen;
